import classNames from 'classnames/bind';
import React from 'react';
import { NoDataDash } from '../../../../../components/formatters';
import { SearchDocumentsDto } from '../../../../../services/dtos/securities/searchDocuments.dto';
import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';

const IssuerNameRenderer = ({
  data,
  columnConfig,
  show,
  row: { isDisabled, isHovered },
}: GroupedTableRowRendererProps<SearchDocumentsDto>): React.ReactElement | null => {
  if (!show) {
    return null;
  }
  return (
    <div className={classNames({ 'gray-out': isDisabled && isHovered })}>
      {data[columnConfig.dataKey] ? <span>{data[columnConfig.dataKey]}</span> : <NoDataDash />}
    </div>
  );
};

export default IssuerNameRenderer;
